import AccessDeniedPage from '../pages/errors/AccessDeniedPage';

export default function AccessDenied() {
    return <AccessDeniedPage />;
}
